<template>
  <div class="topFunction">
    <img :src="list[topValue]" class="back" />
    <!-- <img /> -->

    <div v-for="(item, index) in topList" :key="index" class="center" @click="top(index)">
      <svg-icon
        :icon-class="item.icon"
        :style="
          topValue == index + 1
            ? 'width: 20px;height: 20px;margin-left: -10px;cursor: pointer;color: #fff;'
            : 'width: 20px;height: 20px;margin-left: -10px;cursor: pointer;color: #536b8e;'
        "
      />
    </div>

    <Map :value="topValue" />
    <transition
      enter-active-class="animated fadeInLeft"
      leave-active-class="animated fadeOutLeft"
    >
      <div class="share" v-show="topValue == 2">
        <div class="title">
          INVITATION
          <div class="box1" @click="topValue = 0"></div>
        </div>

        <div id="ewm" ref="ewm"></div>
        <div class="font">
          {{ url }}
          <div class="copy" @click="copy">copy</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Map from "../components/map.vue";
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      topValue: 0,
      topList: [
        { name: "COMMEND", icon: "bmwicon_地图" },
        { name: "APPLAUSE", icon: "bmwicon_邀请1" },
        { name: "CHAT", icon: "bmwicon_拍照" },
        { name: "APPLAUSE", icon: "bmwicon_净化ui" },
        { name: "CHAT", icon: "bmwicon_退出" },
      ],

      list: [
        require("../assets/topImg/0.png"),
        require("../assets/topImg/1.png"),
        require("../assets/topImg/2.png"),
        require("../assets/topImg/3.png"),
        require("../assets/topImg/4.png"),
        require("../assets/topImg/5.png"),
      ],

      flag: true,

      url: "",
    };
  },
  components: {
    Map,
  },
  methods: {
    zipai() {
      var date = new Date().getTime();
      // var name = `自拍${date}`;
      this.compress(document.o2.shot(), 1920, 1080).then((res) => {
        this.$notify({
          title: "成功",
          message: "自拍成功",
          type: "success",
        });
      });
    },
    loginOut() {
      this.$confirm(this.$t("info.lang.logOutInfo"))
        .then((_) => {
          localStorage.removeItem("info");
          location.reload();
          done();
        })
        .catch((_) => {});
    },
    compress(base64String, w, quality) {
      let a = document.createElement("a");

      a.style.display = "none";
      var that = this;
      var getMimeType = function (urlData) {
        var arr = urlData.split(",");
        var mime = arr[0].match(/:(.*?);/)[1];
        // return mime.replace("image/", "");
        return mime;
      };
      var newImage = new Image();
      var imgWidth, imgHeight;

      var promise = new Promise((resolve) => (newImage.onload = resolve));
      newImage.src = base64String;

      return promise.then(() => {
        imgWidth = newImage.width;
        imgHeight = newImage.height;
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        if (Math.max(imgWidth, imgHeight) > w) {
          if (imgWidth > imgHeight) {
            canvas.width = w;
            canvas.height = (w * imgHeight) / imgWidth;
          } else {
            canvas.height = w;
            canvas.width = (w * imgWidth) / imgHeight;
          }
        } else {
          canvas.width = imgWidth;
          canvas.height = imgHeight;
        }
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(newImage, 0, 0, canvas.width, canvas.height);

        let imgobj = new Image();
        imgobj.src = "";

        var base64 = canvas.toDataURL(getMimeType(base64String), quality);
        var blob = that.dataURLToBlob(base64);
        a.setAttribute("href", URL.createObjectURL(blob));
        a.setAttribute("download", "自拍.png");
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(blob);
        document.body.removeChild(a);

        // return base64;
      });
    },

    dataURLToBlob(dataurl) {
      //ie 图片转格式
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    top(e) {
      if (e == 0) {
        if (this.topValue == 1) {
          this.topValue = 0;
          return;
        }
      }

      if (e == 1) {
        if (this.topValue == 2) {
          this.topValue = 0;
          return;
        }
      }

      if (e == 2) {
        this.zipai();
      }

      if (e == 3) {
        this.flag = !this.flag;
        this.Bus.$emit("allclose", this.flag);
      }

      if (e == 4) {
        this.loginOut();
      }
      if (e == 0 || e == 1) {
        this.topValue = e + 1;
      }
    },

    bindQRCode: function () {
      console.log(this.$refs.ewm);
      new QRCode(this.$refs.ewm, {
        text: window.location.href,
        width: 81,
        height: 81,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
      });
    },

    copy() {
      let transfer = document.createElement("input"); //创建控件
      document.body.appendChild(transfer);
      transfer.style.cssText = "position: absolute;right: 45%;top: 80%;";
      transfer.value = this.url; // 这里表示想要复制的内容
      transfer.focus();
      transfer.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
      }
      transfer.blur();
      this.$message.success("复制成功");
      document.body.removeChild(transfer); //删除控件
    },
  },
  mounted() {
    this.url = window.location.href;
    this.bindQRCode();
  },
};
</script>

<style lang="scss" scoped>
.topFunction {
  width: 48.02px;
  height: 300px;

  position: fixed;
  left: 0;
  top: 15px;
}
.title {
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  background: url("../assets/topImg/title.png");
  background-size: 100% 100%;
  font-size: 16.01px;
  font-family: BMW Group, BMW Group-Bold;
  font-weight: 700;
  text-align: left;
  color: #ffffff;
  justify-content: space-between;
  .box1 {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  z-index: 1;
  position: relative;
}
.center:first-of-type {
  margin-top: 15px;
  height: 70px;
}
.back {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.share {
  width: 432.15px;
  height: 145.38px;
  opacity: 0.92;
  background: linear-gradient(0deg, #bbc7d5 0%, #ffffff 100%);
  position: fixed;
  top: 90px;
  left: 60px;
}

#ewm {
  position: absolute;
  width: 81.36px;
  height: 81.36px;

  left: 13px;
  bottom: 10px;
}

.font {
  width: 306.11px;
  height: 62.7px;
  background: linear-gradient(rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.1) 100%);
  position: absolute;
  bottom: 10px;
  right: 0;
  padding: 10px;
  word-wrap: break-word;
  text-align: left;
}

.copy {
  position: absolute;
  right: -10px;
  bottom: -10px;
  width: 120.04px;
  height: 48.02px;
  background: url("../assets/topImg/copy.png");
  background-size: 100% 100%;
  display: flex;
  color: white;
  justify-content: center;
  font-size: 14px;
  font-family: BMW Group, BMW Group-Bold;
  font-weight: 700;
  line-height: 38px;
  cursor: pointer;
}
</style>
